import { render, staticRenderFns } from "./NavigationCartButton.vue?vue&type=template&id=90c54b5e"
import script from "./NavigationCartButton.vue?vue&type=script&lang=js"
export * from "./NavigationCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports